/* ============================================================
   cvt-filtros.js — FRESH GLOSS (oct 2026)
   Buscador + pestañas por familia para la tabla de variantes B2B
   (snippets/custom-variant-table.liquid).

   - Solo muestra/oculta filas [data-cvt-row]; no toca cantidades
     ni el carrito (eso vive en custom-variant-table.js).
   - Pestañas: __disp (disponibles), __todos, o nombre de familia
     (metacampo de variante custom.familia).
   - Buscador: nombre o SKU, sin acentos y tolerante a errores
     de dedo (distancia de Levenshtein). Busca en TODOS los colores.
   ============================================================ */
(function () {
  'use strict';

  function norm(s) {
    return (s || '')
      .toLowerCase()
      .normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9 ]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function lev(a, b) {
    if (a === b) return 0;
    var m = a.length, n = b.length;
    if (!m) return n;
    if (!n) return m;
    var p = [], i, j;
    for (j = 0; j <= n; j++) p[j] = j;
    for (i = 1; i <= m; i++) {
      var prev = p[0];
      p[0] = i;
      for (j = 1; j <= n; j++) {
        var tmp = p[j];
        p[j] = Math.min(p[j] + 1, p[j - 1] + 1, prev + (a[i - 1] === b[j - 1] ? 0 : 1));
        prev = tmp;
      }
    }
    return p[n];
  }

  /* 2 = coincide tal cual, 1 = parecido (error de dedo), 0 = nada */
  function puntaje(q, fila) {
    var nombre = fila._nombre, sku = fila._sku;
    if (nombre.indexOf(q) > -1 || (sku && sku.indexOf(q.replace(/ /g, '')) > -1)) return 2;
    var palabrasN = nombre.split(' ');
    var ok = q.split(' ').every(function (pq) {
      return palabrasN.some(function (pn) {
        if (pn.indexOf(pq) === 0 || pq.indexOf(pn) === 0) return true;
        if (pq.length < 3) return false;
        var tol = pq.length <= 7 ? 1 : 2;
        return lev(pq, pn) <= tol || (pq.length >= 4 && lev(pq, pn.slice(0, pq.length)) <= tol);
      });
    });
    return ok ? 1 : 0;
  }

  function init(wrap) {
    var filtros = wrap.querySelector('[data-cvt-filtros]');
    var tabla = wrap.querySelector('.variant_tag');
    if (!filtros || !tabla || filtros.dataset.cvtInit) return;
    filtros.dataset.cvtInit = '1';

    var filas = Array.prototype.slice.call(tabla.querySelectorAll('[data-cvt-row]'));
    filas.forEach(function (f) {
      f._nombre = norm(f.dataset.nombre);
      f._sku = norm(f.dataset.sku).replace(/ /g, '');
      f._fams = (f.dataset.fam || '').split('|');
    });

    var botones = Array.prototype.slice.call(filtros.querySelectorAll('[data-cvt-fam]'));
    var famBox = filtros.querySelector('.cvt_familias');
    var input = filtros.querySelector('[data-cvt-buscar]');
    var buscarBox = filtros.querySelector('.cvt_buscar');
    var limpiar = filtros.querySelector('[data-cvt-limpiar]');
    var aviso = filtros.querySelector('[data-cvt-aviso]');
    var vacio = wrap.querySelector('[data-cvt-vacio]');
    var activa = '__disp';

    function aplicar() {
      var q = norm(input.value);
      buscarBox.classList.toggle('cvt_con_texto', !!input.value);
      famBox.classList.toggle('cvt_apagadas', !!q);

      var visibles = 0, exactas = 0;
      filas.forEach(function (f) {
        var ver;
        if (q) {
          var p = puntaje(q, f);
          ver = p > 0;
          if (p === 2) exactas++;
        } else if (activa === '__disp') {
          ver = f.dataset.disp === '1';
        } else if (activa === '__todos') {
          ver = true;
        } else {
          ver = f._fams.indexOf(activa) > -1;
        }
        f.hidden = !ver;
        if (ver) visibles++;
      });

      tabla.style.display = visibles ? '' : 'none';
      if (vacio) vacio.hidden = !!visibles;

      if (!q || !visibles) {
        aviso.textContent = '';
      } else if (!exactas) {
        aviso.innerHTML = '¿Quisiste decir…? Te mostramos <b>' + visibles + '</b> color' +
          (visibles > 1 ? 'es parecidos' : ' parecido') + '.';
      } else {
        aviso.innerHTML = '<b>' + visibles + '</b> resultado' + (visibles > 1 ? 's' : '') + ' en todos los colores.';
      }
    }

    famBox.addEventListener('click', function (e) {
      var b = e.target.closest('[data-cvt-fam]');
      if (!b) return;
      activa = b.getAttribute('data-cvt-fam');
      botones.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      if (input.value) input.value = '';
      aplicar();
    });

    var t;
    input.addEventListener('input', function () {
      clearTimeout(t);
      t = setTimeout(aplicar, 120);
    });
    /* Enter no debe enviar ningún formulario de producto */
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') e.preventDefault(); });
    limpiar.addEventListener('click', function () {
      input.value = '';
      aplicar();
      input.focus();
    });

    aplicar();
  }

  function run() {
    document.querySelectorAll('.custom_design_variant').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  /* Editor de temas: re-inicializa al recargar la sección */
  document.addEventListener('shopify:section:load', run);
})();
